var $ = require('jquery');

module.exports = function(el, isResult) {
  var className = isResult ? '' : 'b-selectbox-dropdown_item';
  return $('<span>').addClass(className).text(el.text());
};
